import React from 'react';
import { useCurrency } from '../../../hooks/currency';
import { BalanceType } from '../../../XV2';
import { XBox, XIcon, XList, XRouterLink, XSection, XSectionHeader, XText, XButton } from '@orderx/lab/ui';
import { useMe } from '../../../hooks/me';
import { AccountPage } from '../AccountPage';
import { LocationPage } from '../../location/LocationPage';
import { startCase } from '../../../util/startCase';

export function AccountWalletPage() {
    const me = useMe();
    const currency = useCurrency();
    const balances = me.getBalances();

    return (
        <>
            <XSectionHeader
                title={
                    (
                        <XBox flex gap={4}>
                            <XRouterLink to={AccountPage} style={{ display: 'inline-flex' }}>
                                <XIcon>arrow_back</XIcon>
                            </XRouterLink>

                            <span>Wallet</span>
                        </XBox>
                    ) as any
                }
            />

            <XSection>
                <XList
                    items={balances.map((balance) => {
                        const info = {
                            [BalanceType.INVOICE]: {
                                label: 'Invoice',
                                icon: 'payment',
                            },
                            [BalanceType.CREDIT]: {
                                label: 'Credit',
                                icon: 'redeem',
                            },
                        };

                        const icon = info[balance.type as string]?.icon;
                        const locationBalances = balance.locationBalances;
                        const balanceCurrency = locationBalances[0]?.location?.currency;

                        const subtitle = (
                            <>
                                Valid at{' '}
                                {locationBalances.map(({ locationId, location }, index) => (
                                    <XRouterLink to={[LocationPage, { locationId }]} key={locationId}>
                                        <XText color={'secondary'} weight={3}>
                                            {index > 0 && <>{', '}</>}
                                            {location.name}
                                        </XText>
                                    </XRouterLink>
                                ))}
                            </>
                        );

                        const value = (
                            <XButton variant={'text'}>
                                {currency.format(balance.amountRemaining, balanceCurrency)}
                            </XButton>
                        );

                        return {
                            icon,
                            title: balance.namePublic || startCase(balance?.type || ''),
                            subtitle: subtitle,
                            value: value,
                            onClick() {},
                        };
                    })}
                />
            </XSection>
        </>
    );
}

AccountWalletPage.route = '/account/wallet';
